import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-200d3d92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option-item" }
const _hoisted_2 = { class: "option-item-header" }

import {mdiLoading, mdiMenuDown, mdiMenuUp} from "@mdi/js";

import ProductOption from "@/types/ProductAttributeOption";




import AppLayoutVue from "@/Layouts/AppLayout.vue";


const __default__ = {
  layout: AppLayoutVue,

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ProductAttributeOptionComponent',
  props: {
    modelValue: {}
  },
  setup(__props: any) {

const props = __props;







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "option-item-name",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.value) = $event))
      }, null, 512), [
        [_vModelText, _ctx.modelValue.value]
      ]),
      _renderSlot(_ctx.$slots, "remove-option")
    ])
  ]))
}
}

})